import { useState } from "react";
import api from "../config/axiosConfig";
import { useRfi } from "../contexts/RfiContext";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { hasPermission } from "../utils/utilityFunctions";
import { actionType } from "../utils/constant";

export default function useRFIFooter(stageId) {
  const { rfiDetails, getRFIStages, getRFIDetails } = useRfi();

  const { profile } = useSelector((state) => state.profile);

  const [actionModalOpen, setActionModalOpen] = useState(false);
  const [actionRemark, setActionRemark] = useState("");
  const [modalActionType, setModalActionType] = useState("reject"); // "reject" or "approve"

  // Handle opening the modal for reject action
  const handleRejectClick = () => {
    setModalActionType("reject");
    setActionModalOpen(true);
  };

  // Handle opening the modal for approve action
  const handleApproveClick = () => {
    setModalActionType("approve");
    setActionModalOpen(true);
  };

  // Handle confirming the action with remark
  const handleConfirmAction = async () => {
    let response;
    if (modalActionType === "reject") {
      if (
        !hasPermission(profile?.permissions?.actions, actionType.stage_reject)
      ) {
        toast.error("You do not have permission to reject this stage");
        return;
      }
      response = await actionAPI("reject", actionRemark); // Pass the rejection remark to the parent handler
    } else if (modalActionType === "approve") {
      if (
        !hasPermission(profile?.permissions?.actions, actionType.stage_approve)
      ) {
        toast.error("You do not have permission to approve this stage");
        return;
      }
      response = await actionAPI("approve", actionRemark); // Pass the approval remark to the parent handler
    }
    if (response?.success) {
      setActionModalOpen(false);
      setActionRemark("");
      toast.success(response?.data?.message);
      await getRFIStages(rfiDetails?.rfi_id);
      await getRFIDetails(rfiDetails?.rfi_id);
    } else {
      toast.error(response?.error?.message || "Something went wrong");
    }
  };

  // Handle canceling the action
  const handleCancelAction = () => {
    setActionModalOpen(false);
    setActionRemark("");
  };

  const actionAPI = async (actionType, remark) => {
    if (!stageId || !actionType || !remark) return;
    //API goes below
    return await api
      .post("/api/rfi-stages-workflow/review-stage", {
        stage_id: stageId,
        action: actionType,
        remarks: remark,
      })
      .then((res) => {
        return {
          success: true,
          data: res.data,
        };
      })
      .catch((error) => {
        return {
          success: false,
          error: error,
        };
      });
  };

  return {
    actionModalOpen,
    actionRemark,
    modalActionType,
    rfiDetails,
    handleRejectClick,
    handleApproveClick,
    handleConfirmAction,
    handleCancelAction,
    setActionRemark,
  };
}
